import React from 'react'
import './fee.scss'
import Image from '../../common/Image'

const Fee = ({ setModal, data, type }) => {
    // type === 'actual' 實際金額
    return (
        <div className='modal page-modal'>
            <div className='block'>
                <div className='container'>
                    <div className="page-header">
                        <button className="btn-circle" onClick={() => setModal(true)}>
                            <Image src="/images/icons/close.svg" svg />
                        </button>
                        <div className="page_header__title">
                            <h1 className="font-heading">
                                {
                                    type === 'actual' ? '服務費用' : '預估服務費用'
                                }
                            </h1>
                            <p className="text-secondary text-scale-02">
                                {
                                    type === 'actual' ?
                                        "如有任何費用疑問，請與客服聯繫" :
                                        (<>
                                            即時報價僅供參考，<br />
                                            實際服務項目及應收金額依技術人員現場確認為主
                                        </>)
                                }
                            </p>
                        </div>
                    </div>
                    <div className='fee-container'>
                        <div className='fee-block'>
                            <div className='block'>
                                <div className='title'>優惠項目</div>
                                {
                                    data?.free_item_list.map(fee => (
                                        <div className='flex-justity-between'>
                                            <p>{fee.item}</p>
                                            <p>${fee.price}</p>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className='block'>
                                <div className='title'>收費項目</div>
                                {
                                    data?.item_list.map(fee => (
                                        <div className='flex-justity-between'>
                                            <p>{fee.item}</p>
                                            <p>${fee.price}</p>
                                        </div>
                                    ))
                                }

                            </div>
                            <div className='block'>

                                <div className='title'>其他資訊</div>
                                <div className='flex-justity-between'>
                                    <p>本次服務里程</p>
                                    <p>{data?.actual_distance || 0} 公里</p>
                                </div>
                                <div className='flex-justity-between'>
                                    <p>本次服務產生碳排</p>
                                    {/* <p>{data?.actual_distance*0.235}</p> */}
                                    {/* 一位數進位 */}
                                    <p>
                                        {Math.round((data?.actual_distance * 0.235 || 0) * 100) / 100} kgCO2e</p>
                                </div>
                            </div>
                        </div>
                        <div className='block'>
                            <div className='flex-justity-between calculate-block'>
                                <p>總計</p>
                                <p>${data?.amount || 0}</p>
                            </div>
                        </div>
                    </div>
                    {
                        type && (
                            <div
                                className='contact-block'
                                onClick={() => {
                                    window.open(`tel:0800-018-119`, "_self");
                                }}
                            >
                                <Image src="/images/icons/message.svg" svg />
                                <p>聯繫線上客服</p>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default Fee